<template>
    <div>
        <tab name="3">{{userName}}(ID:{{id}})</tab>
        <user-video :userId="id" :userType="3" :userName.sync="userName"></user-video>
    </div>
</template>

<script>
import Tab from './components/tab';
import UserVideo from '@/views/user/components/user-video';
export default {
    props:{
        id:{
            type:[Number,String],
            default: ''
        }
    },
    components:{
        Tab,UserVideo
    },
    data() {
        return {
            userName:''
        };
    }
}
</script>